import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
const WHATSAPP_URL = 'https://wa.me/16159848577?text=Hola%20Karina%20%F0%9F%91%8B%20Vi%20tus%20servicios%20de%20dise%C3%B1o%20de%20cejas%20en%20Alexa%20Beauty%20y%20me%20gustar%C3%ADa%20agendar%20una%20cita.%20%C2%BFQu%C3%A9%20disponibilidad%20tienes%3F';
const GOLD = '#C9A96E';

/** Distance scrolled before the CTA fades in, so it never competes with the hero. */
const SCROLL_THRESHOLD = 700;
export function FloatingAppointmentCTA() {
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  const [closingVisible, setClosingVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setScrolledPastHero(window.scrollY > SCROLL_THRESHOLD);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    const closing = document.getElementById('cierre-marca');
    if (!closing) return;
    const observer = new IntersectionObserver(([entry]) => setClosingVisible(entry.isIntersecting), {
      rootMargin: '0px 0px -20% 0px'
    });
    observer.observe(closing);
    return () => observer.disconnect();
  }, []);
  const visible = scrolledPastHero && !closingVisible;
  return <AnimatePresence data-id="element-135" data-mp="214ruek2rodwh">
      {visible && <motion.a key="floating-appointment" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} aria-label="Agendar cita de diseño de cejas por WhatsApp" className="fixed right-4 sm:right-6 z-40 inline-flex items-center gap-2 min-h-[44px] sm:min-h-[48px] bg-luxury-black text-white rounded-full pl-4 pr-5 py-2.5 shadow-md shadow-black/10 border border-white/10 font-sans font-medium text-[11px] sm:text-xs tracking-[0.18em] uppercase active:bg-luxury-dark sm:hover:bg-luxury-dark transition-colors duration-300" style={{
      bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))'
    }} data-id="element-136" data-mp="215t8kxf2xgif">
          <MessageCircleIcon className="w-4 h-4 sm:w-[18px] sm:h-[18px] shrink-0" style={{
        color: GOLD
      }} aria-hidden="true" data-id="element-137" data-mp="2s857ytdjt66i" />
          <span className="hidden min-[380px]:inline" data-id="element-138" data-mp="1zj7r8uozjhfv">Agendar cita</span>
          <span className="min-[380px]:hidden" data-id="element-139" data-mp="1zh518anu1ob5">Cita</span>
        </motion.a>}
    </AnimatePresence>;
}